import React from "react";
import { useParams } from "react-router-dom";

import ReportActions from "../ReportActions";
import ReportStatus from "../ReportStatus";
import { useReport, useReportCatalog } from "../api";
import { AthleteDetailReport, LegalFooter } from "../renderers/AthleteReports";
import { usePeriodParam } from "../usePeriodParam";

/** /scout/reportes/:athleteId — coach or external view, decided server-side. */
const ScoutAthleteReportPage = () => {
  const { athleteId } = useParams();
  const [days, setDays] = usePeriodParam();
  const params = { athleteId, days };
  const query = useReport("athlete-detail", params);
  const catalog = useReportCatalog();
  const isCoach = Boolean(catalog.data?.some((entry) => entry.id === "academy-roster"));

  const data = query.data?.data;
  // The external view always covers 28 days (as in the CEO mockup), so the
  // period selector only appears on the coach's view.
  const coachView = data?.view === "coach";

  return (
    <div className="flex flex-1 flex-col overflow-y-auto bg-paper">
      <ReportActions
        title="Reporte del deportista"
        backTo={isCoach ? "/scout/reportes" : `/scout/athletes/${athleteId}`}
        backLabel={isCoach ? "Reportes" : "Ficha"}
        reportId="athlete-detail"
        reportTitle={data ? `Reporte de ${data.athlete.full_name}` : "Reporte del deportista"}
        params={params}
        period={days}
        onPeriodChange={coachView ? setDays : undefined}
      />
      {data ? (
        <>
          <main className="mx-auto w-full max-w-[1080px] px-4 pt-5 pb-6 sm:px-5">
            <AthleteDetailReport data={data} />
          </main>
          <LegalFooter />
        </>
      ) : (
        <ReportStatus query={query} />
      )}
    </div>
  );
};

export default ScoutAthleteReportPage;
